/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Stat_Ats_Pass_LabelInputs */

const en_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS dimensions scored`)
};

const de_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-Dimensionen bewertet`)
};

const fr_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensions ATS évaluées`)
};

const es_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensiones ATS evaluadas`)
};

const it_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dimensioni ATS valutate`)
};

const nl_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-dimensies beoordeeld`)
};

const pl_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wymiary ATS ocenione`)
};

const fi_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-ulottuvuudet arvioitu`)
};

const da_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-dimensioner bedømt`)
};

const sv_landing_stat_ats_pass_label = /** @type {(inputs: Landing_Stat_Ats_Pass_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ATS-dimensioner bedömda`)
};

/**
* | output |
* | --- |
* | "ATS dimensions scored" |
*
* @param {Landing_Stat_Ats_Pass_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_stat_ats_pass_label = /** @type {((inputs?: Landing_Stat_Ats_Pass_LabelInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Stat_Ats_Pass_LabelInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_stat_ats_pass_label(inputs)
	if (locale === "fr") return fr_landing_stat_ats_pass_label(inputs)
	if (locale === "es") return es_landing_stat_ats_pass_label(inputs)
	if (locale === "it") return it_landing_stat_ats_pass_label(inputs)
	if (locale === "nl") return nl_landing_stat_ats_pass_label(inputs)
	if (locale === "pl") return pl_landing_stat_ats_pass_label(inputs)
	if (locale === "fi") return fi_landing_stat_ats_pass_label(inputs)
	if (locale === "da") return da_landing_stat_ats_pass_label(inputs)
	if (locale === "sv") return sv_landing_stat_ats_pass_label(inputs)
	return en_landing_stat_ats_pass_label(inputs)
});